// import
import MasterPegawai from "views/Master/MasterPegawai";
import MasterUPI from "views/Master/MasterUPI";
import MasterProduk from "views/Master/MasterProduk";
import MasterJenisUji from "views/Master/MasterJenisUji";
import Dashboard from "views/Dashboard/Dashboard";
import Tables from "views/Dashboard/Tables";
import Billing from "views/Dashboard/Billing";
import RTLPage from "views/Dashboard/RTL";
import Profile from "views/Dashboard/Profile";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";
import dashJadwal from "views/Dashboard/Jadwal/dashJadwal.js";
import KalenderView from "views/Dashboard/Kalender/KalenderView.js";
import STView from "views/cetak/STSurve";
import LaporanPengujianTable from "views/Dashboard/RptLab/DashLab";
import PiketDashboard from "views/Dashboard/Piket/PiketDashboard.js";
import DisplayBoard from "views/Display/DisplayBoard.js";

import { CalendarIcon } from "@chakra-ui/icons";
import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
   path: "/schedule",
   name: "Penjadwalan",
   icon: <StatsIcon color="inherit" />,
   component: dashJadwal,
   layout: "/admin",
  },
  {
    path: "/kalender",
    name: "Kalender",
    icon: <CalendarIcon color="inherit" />,
    component: KalenderView,
    layout: "/admin",
  },
  {
    path: "/report",
    name: "LaporanKu",
    icon: <StatsIcon color="inherit" />,
    component: Tables,
    layout: "/admin",
  },
  {
    path: "/report-lab",
    name: "LaporanLab",
    icon: <StatsIcon color="inherit" />,
    component: LaporanPengujianTable,
    layout: "/admin",
  },
  {
    path: "/piket",
    name: "Kelola Piket",
    icon: <StatsIcon color="inherit" />,
    component: PiketDashboard,
    layout: "/admin",
  },
  {
    name: "Master",
    collapse: true,
    state: "masterCollapse",
    views: [
      { path: "/master/pegawai", name: "Pegawai", icon: <HomeIcon color="inherit" />, component: MasterPegawai, layout: "/admin" },
      { path: "/master/upi", name: "UPI", icon: <HomeIcon color="inherit" />, component: MasterUPI, layout: "/admin" },
      { path: "/master/produk", name: "Produk", icon: <HomeIcon color="inherit" />, component: MasterProduk, layout: "/admin" },
      { path: "/master/jenis-uji", name: "Jenis Uji", icon: <HomeIcon color="inherit" />, component: MasterJenisUji, layout: "/admin" },
    ],
  },

  // {
  //   path: "/billing",
  //   name: "Billing",
  //   rtlName: "لوحة القيادة",
  //   icon: <CreditIcon color="inherit" />,
  //   component: Billing,
  //   layout: "/admin",
  // },
  // {
  //       path: "/stsurve",
  //       name: "st surve",
  //       icon: <DocumentIcon color="inherit" />,
  //       component: STView,
  //       layout: "/auth",
  //     },
  // {
  //   path: "/rtl-support-page",
  //   name: "RTL",
  //   rtlName: "آرتيإل",
  //   icon: <SupportIcon color="inherit" />,
  //   component: RTLPage,
  //   layout: "/rtl",
  // },
  {
    name: "ACCOUNT PAGES",
    category: "account",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
      },
      {
        path: "/signin",
        name: "Log out",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/display",
        name: "Display Board",
        icon: <DocumentIcon color="inherit" />,
        component: DisplayBoard,
        layout: "/auth",
      },
      
      // {
      //   path: "/signup",
      //   name: "Sign Up",
      //   icon: <RocketIcon color="inherit" />,
      //   secondaryNavbar: true,
      //   component: SignUp,
      //   layout: "/auth",
      // },
    ],
  },
];
export default dashRoutes;
